import * as React from 'react';
import dayjs from 'dayjs';
import Button from '@mui/material/Button';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';

export default function StaticCurrentDate() {
  const currentDate = dayjs().format('MMM DD');

  return (
    <Button
      variant="outlined"
      startIcon={<CalendarTodayRoundedIcon fontSize="small" />}
      size="small"
      sx={{
        minWidth: 'fit-content',
        color: 'primary.main',
        borderColor: 'primary.main',
      }}
    >
      {currentDate}
    </Button>
  );
}